'use client';

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { analytics } from '@/lib/analytics';

interface CTASectionProps {
  className?: string;
}

const CTASection = ({ className = '' }: CTASectionProps) => {
  const benefits = [
    'Free, no-obligation quote',
    'Flexible scheduling options',
    'Satisfaction guaranteed',
    'Transparent pricing'
  ];

  return (
    <section className={`py-20 bg-gradient-to-br from-accent via-surface to-white ${className}`}>
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-brand-lg p-8 lg:p-12">
            <div className="text-center mb-8">
              <h2 className="font-serif text-4xl lg:text-5xl font-semibold text-foreground mb-6">
                Ready to Experience the Difference?
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto">
                Join thousands of homeowners who trust Crystal Clean for their exterior maintenance. Get your free quote today and discover what quality service really means.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-4 mb-8 max-w-2xl mx-auto">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center space-x-3 bg-surface rounded-lg p-4">
                  <Icon name="CheckCircleIcon" size={20} className="text-success flex-shrink-0" variant="solid" />
                  <span className="text-sm font-medium text-foreground">{benefit}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                href="/get-quote"
                className="inline-flex items-center justify-center px-8 py-4 bg-green-600 text-white font-semibold rounded-full hover:bg-green-700 transition-smooth shadow-brand btn-bubbly"
                onClick={() => analytics.trackCTAClick('Get Free Quote', 'Homepage CTA Section')}
              >
                Get Your Free Quote
                <Icon name="ArrowRightIcon" size={20} className="ml-2" />
              </Link>
              <a
                href="tel:5551234567"
                className="inline-flex items-center justify-center px-8 py-4 bg-blue-600 text-white font-semibold rounded-full hover:bg-blue-700 transition-smooth shadow-brand btn-bubbly"
                onClick={() => analytics.trackCTAClick('Call Now', 'Homepage CTA Section')}
              >
                <Icon name="PhoneIcon" size={20} className="mr-2" />
                <span>(236) 867-2004</span>
              </a>
            </div>

            <p className="text-center text-sm text-muted-foreground mt-6">
              Available Monday - Sunday 8:00 AM - 8:00 PM
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;